import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Options from './Options';
import View from './view';

// Main parent component
function Reports() {
  // --- UPDATED: State matches the new UI flow ---
  const [reportOptions, setReportOptions] = useState({
    // Step 1
    selectedClass: '',

    // Step 2
    reportKind: '', // Will be 'Periodic', 'Lesson', or 'Mock'

    // Step 3 (Conditional)
    // For 'Periodic'
    periodicType: '', // Will be 'Activity', 'Mock', or 'Test'
    from: '',
    to: '',

    // For 'Lesson'
    selectedLessons: [], // Array of lesson IDs

    // For 'Mock'
    selectedMock: '', // Single mock ID

    // Step 4
    selectedUsers: [], // This is still the final (optional) step
  });

  // --- Handlers (validation would go here) ---

  const handleSendEmail = () => {
    console.log('Sending report via EMAIL with options:', reportOptions);
    alert('Email sending logic would run here. Check the console.');
  };

  const handleSendWhatsApp = () => {
    console.log('Sending report via WHATSAPP with options:', reportOptions);
    alert('WhatsApp sending logic would run here. Check the console.');
  };

  return (
    <Container fluid className="my-4">
      <Row>
        <Col md={4}>
          <Options
            options={reportOptions}
            setOptions={setReportOptions}
            onSendEmail={handleSendEmail}
            onSendWhatsApp={handleSendWhatsApp}
          />
        </Col>
        <Col md={8}>
          <View options={reportOptions} />
        </Col>
      </Row>
    </Container>
  );
}

export default Reports;